import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      stroke="#00D8D8"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M7.872 47.917a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
    />
    <path
      fill="#D8FFFF"
      d="M105.37 40.316a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      d="M72.129 84.108a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      stroke="#00D8D8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M101.624 81.688 91.63 91.68M101.624 91.682l-9.994-9.995M23.811 11.782v14.134M30.878 18.85H16.745"
    />
    <path
      stroke="#00D8D8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4.5}
      d="M58 20v76M47 97h22M27 41l63-14M12 75l14.989-34L42 75"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M10 76h34s-4.067 12.897-17.013 13C12.97 89.11 10 76 10 76"
      clipRule="evenodd"
    />
    <path
      stroke="#00D8D8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4.5}
      d="M9 76h36M75 61l14.989-34L105 61"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M73 62h34s-4.067 12.897-17.013 13C75.97 75.11 73 62 73 62"
      clipRule="evenodd"
    />
    <path
      stroke="#00D8D8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4.5}
      d="M72 62h36"
    />
    <path
      fill="#0597A3"
      d="M27 45a4 4 0 1 0 0-8 4 4 0 0 0 0 8M90 31a4 4 0 1 0 0-8 4 4 0 0 0 0 8M58 40a6 6 0 1 0 0-12 6 6 0 0 0 0 12M56.114 89h3.773C62.157 89 64 90.731 64 92.862V95H52v-2.138C52 90.73 53.844 89 56.114 89"
    />
  </svg>
);
const SvgEnrichedIconBudgetBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconBudgetBrand);
export default Memo;
